/*
 *
 *  * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import { default as React, ReactNode, createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ToastType } from "../components/common/Toast/Toast";

interface Props {
  children: ReactNode;
}
export interface ToastContextValue {
  isDisplayed: boolean;
  message: string;
  type: ToastType;
  displayToast: Function;
  hideToast: Function; // SB-259 add hideToast for Starbreeze
}
export const ToastContext = createContext<ToastContextValue>({
  isDisplayed: false,
  message: "",
  type: "success",
  displayToast: () => null,
  hideToast: () => null, // SB-259 set default hideToast value for Starbreeze
});

const ToastProvider = ({ children }: Props) => {
  const [isDisplayed, setIsDisplayed] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [type, setType] = useState<ToastType>("success");
  const location = useLocation();

  const displayToast = (message: string, type: ToastType) => {
    // SB-259 remove set time out for Starbreeze: START
    setType(type);
    setMessage(message);
    setIsDisplayed(true);
    // SB-259 remove set time out for Starbreeze: END
  };

  // SB-259 Add hide tost function for Starbreeze: START
  const hideToast = () => {
    setIsDisplayed(false);
  };

  useEffect(() => {
    hideToast();
  }, [location.pathname]);

  return (
    <ToastContext.Provider value={{ isDisplayed, message, type, displayToast, hideToast }}>
      {children}
    </ToastContext.Provider>
  );
  // SB-259 Add hide tost function for Starbreeze: END
};

export default ToastProvider;
